import React from 'react';
import { NavLink } from 'react-router-dom';
import { Grid } from '@mui/material';
import { NAV_LINKS } from 'consts';

import { CustomGrid, CustomLink } from './styles';

const DesktopNavLinks = () => (
  <CustomGrid
    container
    item
    columnSpacing={{ xs: 1, md: 2 }}
    rowSpacing={1}
    justifyContent="center"
    alignItems="center"
    gap={4}
    display={{ md: 'flex', xs: 'none' }}
  >
    {NAV_LINKS.map((link) => (
      <Grid key={link.path} item>
        <CustomLink component={NavLink} to={link.path}>
          {link.name}
        </CustomLink>
      </Grid>
    ))}
  </CustomGrid>
);

export default DesktopNavLinks;
